import React from 'react'
import { Box, Container, Typography, Divider, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface Section {
  titleKey: string
  contentKey: string
}

interface LegalPageProps {
  titleKey: string
  sections: Section[]
}

export const LegalPage: React.FC<LegalPageProps> = ({ titleKey, sections }) => {
  const { t } = useTranslation()

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Link component={RouterLink} to="/" underline="hover" sx={{ fontWeight: 700, fontSize: '1.2rem', color: 'text.primary', display: 'inline-block', mb: 4 }}>
        ← Orelytics
      </Link>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 4 }}>
        {t(titleKey)}
      </Typography>
      <Divider sx={{ mb: 4 }} />
      {sections.map((s, i) => (
        <Box key={i} sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {t(s.titleKey)}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            {t(s.contentKey)}
          </Typography>
        </Box>
      ))}
    </Container>
  )
}
